import * as FaSvgLib from '@fortawesome/free-solid-svg-icons';
import { withList } from '../../utils';
import { FaIcon } from './common';
const allIcons = Object
    .values(FaSvgLib)
    .filter((icon) => !!icon.icon && icon.iconName != 'font-awesome-logo-full')
    .map((icon) => 'fa-' + icon.iconName);
export default () => {
    return withList({
        defaultItem: FaIcon({
            icon$: (scope) => scope.item
        }),
        injections: {
            items: () => allIcons
        },
    });
};
